export default class {
    constructor() {
        this.initUnfreeze()
    }

    public initUnfreeze() {
        // tslint:disable-next-line:only-arrow-functions
        Object['unfreeze'] = function (o: any) {
            let oo: any;
            if (o instanceof Array) {
                oo = [];
                const clone = (v: any) => { oo.push(v) };
                o.forEach(clone);
            } else if (o instanceof String) {
                // tslint:disable-next-line:no-construct
                oo = new String(o).toString();
            } else if (typeof o === 'object') {
                oo = {};
                // tslint:disable-next-line:forin
                for (const property in o) { oo[property] = o[property]; }
            }
            return oo;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/helpers/Object.ts